/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Time_Field_HelpInputs */

const en_workflow_time_field_help = /** @type {(inputs: Workflow_Time_Field_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you forgot to log it earlier, set the actual time. Future times aren't allowed.`)
};

const ja_workflow_time_field_help = /** @type {(inputs: Workflow_Time_Field_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記録を忘れた場合は実際の時刻を設定してください。未来の時刻は使用できません。`)
};

const fr_workflow_time_field_help = /** @type {(inputs: Workflow_Time_Field_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si vous avez oublié de l’enregistrer plus tôt, indiquez l’heure réelle. Les heures futures ne sont pas autorisées.`)
};

const de_workflow_time_field_help = /** @type {(inputs: Workflow_Time_Field_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du vergessen hast, es früher zu erfassen, setze die tatsächliche Zeit. Zukünftige Zeiten sind nicht erlaubt.`)
};

/**
* | output |
* | --- |
* | "If you forgot to log it earlier, set the actual time. Future times aren't allowed." |
*
* @param {Workflow_Time_Field_HelpInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const workflow_time_field_help = /** @type {((inputs?: Workflow_Time_Field_HelpInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Time_Field_HelpInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_time_field_help(inputs)
	if (locale === "ja") return ja_workflow_time_field_help(inputs)
	if (locale === "fr") return fr_workflow_time_field_help(inputs)
	return de_workflow_time_field_help(inputs)
});